import React,{useState, useContext} from "react";
import { Button,Dropdown,Menu, Modal, message } from "antd";
import { UnorderedListOutlined, CaretDownOutlined, SelectOutlined, PaperClipOutlined, CloseOutlined, 
  ExclamationCircleOutlined, DeleteOutlined} from "@ant-design/icons";
import { useAtom } from "jotai";
//import { useModalDetalleVacaciones } from "../../hooks";
import {solicitudAusenciaSeleccionadaAtom,visibleModalSeguimientoAtom,visibleModalAdjuntarAltaMedicaAtom,
  visibleModalEliminarSolicitudAtom, solicitudesAusenciaAtom} from "../../consultaSolicitudesStore";
import  {SolicitudAusenciaService} from "services";
import { SecurityContext } from "../../../../../../context/SecurityContextProvider";

const { confirm } = Modal;

const MenuAcciones = ({ solicitud }) => {
  const { getUsuarioAutenticado } = useContext(SecurityContext);
  const [loading, setLoading] = useState(false);
  //const { mostrarModal: mostrarModalDetalleVacaciones } = useModalDetalleVacaciones();
   const [solicitudSeleccionada,setSolicitudSeleccionada] = useAtom(solicitudAusenciaSeleccionadaAtom);
   const [visibleModalSeguimiento,setVisibleModalSeguimiento] = useAtom(visibleModalSeguimientoAtom);
   const [visibleModalAltaMedica,setVisibleModalAltaMedica]=useAtom(visibleModalAdjuntarAltaMedicaAtom);
   const [visibleModalEliminarSolictud,setVisibleModalEliminarSolictud]=useAtom(visibleModalEliminarSolicitudAtom);
   const [solicitudesAusencia, setSolicitudesAusencia] = useAtom(solicitudesAusenciaAtom);

  const onClickMenu = (opcion) => {
    switch (opcion.key) {
        case 'seguimientos':
            onClickMenuSeguimientos();
            break; 
         case 'adjuntarAltaMedica':
            onClickAdjuntarAltaMedica(); 
            break;   
        case 'eliminarSolicitud':
            onClickEliminarSolicitud(); 
            break;  
        default:
            console.error("No se encuentra esa opción");
    }
  }
  
  const onClickEliminarSolicitud=()=>{
    //En caso quieran agregar un motivo usar el modal
    // setSolicitudSeleccionada(solicitud);
    // setVisibleModalEliminarSolictud(true);

    Modal.confirm({
			icon: <ExclamationCircleOutlined />,
			content: "¿Está seguro de cancelar la solicitud ?",
			onOk() {
				cancelarSolicitud();
			},
			onCancel() {},
			okText: "Si",
			cancelText: "No",
		});

    const cancelarSolicitud = async () => {
      try{
        const response = await SolicitudAusenciaService.cancelarSolicitudFromAdmin({ 
          solicitudAusenciaId: solicitud.id,
          id:getUsuarioAutenticado().id,
          numeroDocumentoIdentidad:getUsuarioAutenticado().numeroDocumentoIdentidad,
          nombreCompleto:getUsuarioAutenticado().nombreCompleto
        });
        const _documentos = [...solicitudesAusencia]; //siempre se debe generar un nuevo array
        const indice = solicitudesAusencia.findIndex((solicitud) => solicitud.id === solicitud.id);
        const detalleModificar = solicitudesAusencia[indice];
      
        const detalleModificado = {
          ...detalleModificar,
          estado:"CANCELADO"
        }
        _documentos.splice(indice, 1, detalleModificado);
        setSolicitudesAusencia(_documentos);
        
        
        message.success("Se ha cancelado la solicitud correctamente.");
      } catch (error) {
       
        message.error("Ocurrio un error al realizar la solicitud");
     }
    
  
       // if (response.estado === ApiResponse.EXITO) {
      //   message.success("Se ha cancelado la solicitud correctamente.");
  
      //   cargarDatos();
      // } else {
      //   message.error(response.mensaje);
      // }
    };

  }
  const onClickMenuSeguimientos=()=>{
      setSolicitudSeleccionada(solicitud);
      setVisibleModalSeguimiento(true);
  }

  const onClickAdjuntarAltaMedica=()=>{
    setSolicitudSeleccionada(solicitud);
    setVisibleModalAltaMedica(true);
  }
  const menu = () => {
	  const isAceros = getUsuarioAutenticado().empresaSeleccionada.razonSocial.toUpperCase().includes("ACEROS CHILCA SAC")
		? true
		: false;

    const isGlore =
          getUsuarioAutenticado().empresaSeleccionada?.ruc === "20555936045"
            ? true
            : false;

    const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
    const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

    const handleEliminarSolicitudSDF = () => {
      confirm({
        title: '¿Está seguro de eliminar esta solicitud?',
        icon: <ExclamationCircleOutlined />,
        content: `Se eliminará la solicitud de ${solicitud.colaborador?.nombreCompleto}. Quedará registrado que fue eliminada por un administrador.`,
        okText: 'Sí, eliminar',
        okType: 'danger',
        cancelText: 'Cancelar',
        onOk: async () => {
          try {
            setLoading(true);
            await SolicitudAusenciaService.eliminarSolicitudPorAdmin(solicitud.id);
            message.success('Solicitud eliminada correctamente');

            const _documentos = [...solicitudesAusencia]; //siempre se debe generar un nuevo array
            const indice = solicitudesAusencia.findIndex((s) => s.id === solicitud.id);
            const detalleModificar = solicitudesAusencia[indice];

            const detalleModificado = {
              ...detalleModificar,
              estado: "RECHAZADO",
              informacionAdicional: {
                ...(detalleModificar.informacionAdicional || {}),
                eliminadoPorAdmin: true,
                nombreAdminElimino: getUsuarioAutenticado().nombreCompleto,
              },
            };
            _documentos.splice(indice, 1, detalleModificado);
            setSolicitudesAusencia(_documentos);
          } catch (error) {
            message.error(error.response?.data?.mensaje || 'Error al eliminar la solicitud');
          } finally {
            setLoading(false);
          }
        },
      });
    };

    const handleRegenerarConvenio = () => {
      confirm({
        title: '¿Regenerar el convenio de esta solicitud?',
        icon: <ExclamationCircleOutlined />,
        content: `Se intentará generar nuevamente el convenio de fraccionamiento/adelanto de ${solicitud.colaborador?.nombreCompleto} que quedó pendiente. El colaborador deberá firmarlo desde su portal; los días de vacaciones ya fueron descontados y no se ven afectados por esto.`,
        okText: 'Sí, regenerar',
        cancelText: 'Cancelar',
        onOk: async () => {
          try {
            setLoading(true);
            await SolicitudAusenciaService.regenerarConvenio(solicitud.id);
            message.success('Convenio regenerado correctamente');

            const _documentos = [...solicitudesAusencia];
            const indice = solicitudesAusencia.findIndex((s) => s.id === solicitud.id);
            const detalleModificar = solicitudesAusencia[indice];

            const informacionAdicional = { ...(detalleModificar.informacionAdicional || {}) };
            delete informacionAdicional.erroresGeneracionConvenio;
            delete informacionAdicional.erroresGeneracionConvenioFecha;

            const detalleModificado = {
              ...detalleModificar,
              informacionAdicional,
            };
            _documentos.splice(indice, 1, detalleModificado);
            setSolicitudesAusencia(_documentos);
          } catch (error) {
            message.error(error.response?.data?.mensaje || 'Error al regenerar el convenio');
          } finally {
            setLoading(false);
          }
        },
      });
    };

    const handleEliminarVacaciones = () => {
        confirm({
        title: '¿Está seguro de eliminar esta solicitud de vacaciones?',
        icon: <ExclamationCircleOutlined />,
        content: `Se eliminarán las vacaciones del colaborador ${solicitud.colaborador?.nombreCompleto} y se revertirán los días solicitados (${solicitud.diasSolicitados} días).`,
        okText: 'Sí, eliminar',
        okType: 'danger',
        cancelText: 'Cancelar',
        onOk: async () => {
          try {
            setLoading(true);
            await SolicitudAusenciaService.eliminarVacaciones(solicitud.id);
            message.success('Vacaciones eliminadas correctamente');
            
            const _documentos = [...solicitudesAusencia]; //siempre se debe generar un nuevo array
            const indice = solicitudesAusencia.findIndex((solicitud) => solicitud.id === solicitud.id);
            const detalleModificar = solicitudesAusencia[indice];
          
            const detalleModificado = {
              ...detalleModificar,
              estado:"RECHAZADO"
            }
            _documentos.splice(indice, 1, detalleModificado);
            setSolicitudesAusencia(_documentos);
            // Callback para refrescar la lista
            // if (onEliminarExito) {
            //   onEliminarExito();
            // }
          } catch (error) {
            message.error(error.response?.data?.mensaje || 'Error al eliminar las vacaciones');
          } finally {
            setLoading(false);
          }
        },
      });
  };

    return (
        <Menu onClick={onClickMenu}>
            <Menu.Item key="seguimientos">
                <SelectOutlined /> Seguimientos
            </Menu.Item>
            <Menu.Item key="adjuntarAltaMedica">
              <PaperClipOutlined /> Adjuntar alta médica
            </Menu.Item>
            { solicitud?.admin && isAceros && solicitud?.estado =="APROBADO" &&(
              <Menu.Item key="eliminarSolicitud">
                <CloseOutlined /> Eliminar
              </Menu.Item>
            )}
            { solicitud?.tipo?.descripcion=="VACACIONES" &&  isGlore && solicitud?.estado =="APROBADO" &&(
              <Menu.Item
                key="rechazarSolicitud"
                icon={<DeleteOutlined />}
                onClick={handleEliminarVacaciones}
                danger >
                 Eliminar
              </Menu.Item>
            )}
            { (isSDF || isSDFEnergia) && solicitud?.estado == "APROBADO" && (
              <Menu.Item
                key="eliminarSolicitudSDF"
                icon={<DeleteOutlined />}
                onClick={handleEliminarSolicitudSDF}
                danger >
                 Eliminar
              </Menu.Item>
            )}
            { (isSDF || isSDFEnergia) && solicitud?.informacionAdicional?.erroresGeneracionConvenio && (
              <Menu.Item
                key="regenerarConvenio"
                icon={<ExclamationCircleOutlined />}
                onClick={handleRegenerarConvenio} >
                 Regenerar convenio
              </Menu.Item>
            )}
        </Menu>
    )
}
  
  return (   
    <React.Fragment>
        <Dropdown
                overlay={menu}
                trigger={['click']}
                placement="bottomCenter">

                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    <UnorderedListOutlined style={{ fontSize: '16px', fontWeight: 'bold', color: "#1678c1" }} />
                    <CaretDownOutlined style={{ paddingLeft: '2px', fontSize: '12px', fontWeight: 'bold', color: "#1678c1" }} />
                </a>

          </Dropdown>
         
    </React.Fragment> 
         
  );
}

export default MenuAcciones;
